import { render } from "./ContentTree.vue?vue&type=template&id=4c6cdf95&scoped=true"
import script from "./ContentTree.vue?vue&type=script&lang=js"
export * from "./ContentTree.vue?vue&type=script&lang=js"

import "./ContentTree.vue?vue&type=style&index=0&id=4c6cdf95&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6cdf95"]])

export default __exports__